import { useContext } from 'react';
import { BillCreationContext } from '../../features/providers/TaskCreationProvider/TaskCreationProvider';

export const useTaskCreationContext = () => {
  return useContext(BillCreationContext);
};
